'use client';

import React, { PropsWithChildren, useContext } from 'react';
import { useQuery } from 'react-query';
import { useFetch } from './FetchProvider';
import { VideoWatchStatus } from '@elsevier-health/osmosis-shared/typings';

type WatchProgressContext = {
  watchProgress?: Record<string, VideoWatchStatus>;
  isLoading: boolean;
};

const WatchProgressContext = React.createContext<WatchProgressContext>({
  isLoading: true,
});

type WatchProgressProps = {
  isLoggedInView: boolean;
};
/**
 * Provides the LearnData context.
 * @param props - The component props.
 */
export const WatchProgressProvider = ({
  isLoggedInView,
  children,
}: PropsWithChildren<WatchProgressProps>) => {
  const { get } = useFetch();

  const { data: watchProgress, isLoading } = useQuery(
    'watchProgress',
    async () => {
      if (!isLoggedInView) {
        return Promise.resolve(null);
      }

      const { data } = await get<Record<string, VideoWatchStatus>>(
        '/api/learn/watch-progress',
      );

      return data;
    },
  );

  return (
    <WatchProgressContext.Provider
      value={
        {
          watchProgress,
          isLoading,
        } as WatchProgressContext
      }
    >
      {children}
    </WatchProgressContext.Provider>
  );
};

/**
 * Hook to access the sidebar playlist watch progress context.
 */
export const useWatchProgress = (): WatchProgressContext =>
  useContext(WatchProgressContext);
